import './App.css';
import Home from './containers/home/Home';
import About from './containers/about/About';

function App() {
  return (
    <div className="App">
      <Home />
      <About />
    </div>
  );
}

export default App;
